import React, { useState } from 'react';
import { Bell, Send, Users, CheckCircle, Clock, AlertCircle } from 'lucide-react';
import { Select } from 'antd';
const { Option } = Select;

const sentNotifs = [
  { id: 'N001', title: 'New League Started!', body: 'Vegas Grand Prix 2025 is now open for registration.', target: 'All Users', sent: '2 hrs ago', status: 'Delivered', reach: 4821 },
  { id: 'N002', title: 'Race Results Published', body: 'Check out the results for Desert Sprint Round 5.', target: 'Racers', sent: '1 day ago', status: 'Delivered', reach: 2140 },
  { id: 'N003', title: 'Maintenance Notice', body: 'Platform will be down for 30 min on Sunday 2AM.', target: 'All Users', sent: '2 days ago', status: 'Delivered', reach: 4821 },
  { id: 'N004', title: 'Special Offer – 20% Off', body: 'Use code VEGAS20 for 20% off your next race entry.', target: 'Inactive', sent: '3 days ago', status: 'Delivered', reach: 784 },
  { id: 'N005', title: 'Weekend Race Reminder', body: 'Your race is scheduled for Saturday at 6PM.', target: 'Racers', sent: 'Scheduled', status: 'Pending', reach: 2140 },
  { id: 'N006', title: 'Welcome New Racers!', body: 'Welcome to Vegas Karts. Let the racing begin!', target: 'New Users', sent: 'Failed', status: 'Failed', reach: 0 },
];

function PushNotification() {
  const [form, setForm] = useState({ title: '', body: '', target: 'All Users', schedule: 'now' });
  const [sent, setSent] = useState(false);

  const handleSend = () => {
    setSent(true);
    setTimeout(() => setSent(false), 3000);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Push Notification</h1>
          <p className="page-subtitle">Broadcast messages to Vegas Karts users.</p>
        </div>
      </div>

      {/* Stats */}
      <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', marginBottom: 24 }}>
        {[
          { label: 'Sent Today', value: '3', icon: <Send size={20} />, color: 'red' },
          { label: 'Total Reach', value: '4,821', icon: <Users size={20} />, color: 'orange' },
          { label: 'Delivered', value: '98.2%', icon: <CheckCircle size={20} />, color: 'green' },
          { label: 'Pending', value: '1', icon: <Clock size={20} />, color: 'yellow' },
        ].map(s => (
          <div className="stat-card" key={s.label}>
            <div className={`stat-icon ${s.color}`}>{s.icon}</div>
            <div className="stat-info">
              <div className="stat-label">{s.label}</div>
              <div className="stat-value">{s.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="grid-2" style={{ alignItems: 'start' }}>
        {/* Compose */}
        <div className="card" style={{marginBottom:"24px"}}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
            <div style={{ width: 40, height: 40, background: 'var(--accent-gradient)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
              <Bell size={18} />
            </div>
            <div>
              <h3 className="font-heading" style={{ fontSize: 16 }}>Compose Notification</h3>
              <p style={{ fontSize: 12, color: 'var(--text-muted)' }}>Create and send a push notification</p>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Notification Title</label>
            <input className="form-control" placeholder="Enter notification title..." value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} />
          </div>

          <div className="form-group">
            <label className="form-label">Message Body</label>
            <textarea className="form-control" placeholder="Write your notification message..." value={form.body} onChange={e => setForm(p => ({ ...p, body: e.target.value }))} style={{ minHeight: 100 }} />
            <div style={{ textAlign: 'right', fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>{form.body.length}/160</div>
          </div>

          <div className="form-group">
            <label className="form-label">Target Audience</label>

            <Select
              value={form.target}
              onChange={(value) => setForm(p => ({ ...p, target: value }))}
              style={{ width: '100%' }}
              size="large"
              className="form-control vk-select"
              popupClassName="vk-select-popup"
              popupMatchSelectWidth={true}
              placement="bottomLeft"
            >
              <Option value="All Users">All Users</Option>
              <Option value="Racers">Racers</Option>
              <Option value="Spectators">Spectators</Option>
              <Option value="Inactive Users">Inactive Users</Option>
              <Option value="New Users (last 7 days)">New Users (last 7 days)</Option>
            </Select>
          </div>

          <div className="form-group">
            <label className="form-label">Schedule</label>
            <div style={{ display: 'flex', gap: 10 }}>
              {[{ val: 'now', label: 'Send Now' }, { val: 'schedule', label: 'Schedule' }].map(opt => (
                <button key={opt.val} onClick={() => setForm(p => ({ ...p, schedule: opt.val }))}
                  style={{
                    flex: 1, padding: '9px', borderRadius: 8, border: '1px solid',
                    borderColor: form.schedule === opt.val ? 'var(--accent-red)' : 'var(--border)',
                    background: form.schedule === opt.val ? 'rgba(232,0,29,0.12)' : 'transparent',
                    color: form.schedule === opt.val ? 'var(--text-primary)' : 'var(--text-muted)',
                    cursor: 'pointer', fontFamily: 'JetBrains Mono, monospace', fontWeight: 600, fontSize: 13, transition: 'all 0.2s',
                  }}>{opt.label}</button>
              ))}
            </div>
          </div>

          {form.schedule === 'schedule' && (
            <div className="form-group">
              <label className="form-label">Schedule Date & Time</label>
              <input type="datetime-local" className="form-control" />
            </div>
          )}

          {sent && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.2)', borderRadius: 8, marginBottom: 16, color: '#10b981', fontSize: 13 }}>
              <CheckCircle size={16} /> Notification sent successfully!
            </div>
          )}

          <button className="btn-primary" style={{ width: '100%', justifyContent: 'center', padding: 12 }} onClick={handleSend}>
            <Send size={15} /> Send Notification
          </button>
        </div>

        {/* Preview */}
        <div>
          <div className="card" style={{ marginBottom: 24 }}>
            <h3 className="font-heading" style={{ fontSize: 15, marginBottom: 16 }}>Preview</h3>
            <div style={{ background: 'rgba(0,0,0,0.4)', borderRadius: 12, padding: 16, border: '1px solid var(--border)' }}>
              <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div style={{ width: 40, height: 40, background: 'var(--accent-gradient)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <span style={{ fontFamily: 'Bebas Neue, cursive', fontSize: 14, color: '#fff', letterSpacing: 1 }}>VK</span>
                </div>
                <div>
                  <div style={{ fontFamily: 'JetBrains Mono, monospace', fontWeight: 700, fontSize: 14, color: 'var(--text-primary)', marginBottom: 4 }}>{form.title || 'Notification Title'}</div>
                  <div style={{ fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.5 }}>{form.body || 'Your notification message will appear here...'}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6 }}>Vegas Karts • Just now</div>
                </div>
              </div>
            </div>
          </div>

          {/* Recent notifications */}
          <div className="card">
            <h3 className="font-heading" style={{ fontSize: 15, marginBottom: 16 }}>Recent Notifications</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {sentNotifs.map(n => (
                <div key={n.id} style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 12px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontFamily: 'JetBrains Mono, monospace', fontWeight: 600, fontSize: 13, color: 'var(--text-primary)', marginBottom: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n.title}</div>
                      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{n.target} • {n.sent}</div>
                    </div>
                    <span className={`badge ${n.status === 'Delivered' ? 'badge-success' : n.status === 'Failed' ? 'badge-danger' : 'badge-warning'}`} style={{ fontSize: 10, flexShrink: 0 }}>
                      {n.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PushNotification;